import AppointmentForm from '../../components/AppointmentForm/AppointmentForm'
import React from 'react'
import Container from 'react-bootstrap/Container'
import bg from '../../assets/img/bg.jpg'
import SEO from '../../components/SEO'
import './Appointment.css'

const Appointment = () => {
  const heroStyle = {
    backgroundImage: `url(${bg})`,
    height: '40vh',
    marginTop: '-70px',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
  }

  return (
    <>
      <Container className="appointment-hero" style={heroStyle} fluid>
        <SEO title="Book Appointment" description="Schedule your braiding or styling appointment at Sarah Adom Braiding Salon in Manassas, VA." />
        <div className="appointment-hero-content">
          <h1>Book Your Appointment</h1>
          <p>Professional braiding and styling in Manassas, VA</p>
        </div>
      </Container>

      <Container className="appointment-body py-4">
        <p className="appointment-deposit-note">
          A 30% deposit is required to secure your booking (Zelle, Cash App, or Card). After submitting, please call{' '}
          <a href="tel:7039363026">703-936-3026</a> to confirm your appointment.
        </p>
        <AppointmentForm />
      </Container>
    </>
  )
}

export default Appointment
